:host {
  display: inline-block;
}

:host([open]) aha-date-input {
  box-shadow: 0 0 0 2px rgba(var(--rgb-blue-500), 0.5);
}

:host [slot='control'] {
  display: inline-flex;
  align-items: stretch;
}

:host aha-menu {
  height: inherit;
  width: inherit;
}

:host aha-menu-content {
  overflow: hidden;
}

:host([full-width]) {
  aha-date-input {
    width: 100%;
  }

  input {
    max-width: unset;
  }
}
